import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import LoadingSkeleton from "../../../loader/TableLoader";
import {
  NoItemsLeftInTable,
  capitalizeFirstLetter,
  handleDateSetUp,
} from "../../../../helpers/helpers";
import { Modal } from "react-materialize";
import InspectionModal from "../../../sellerAuction/inspection/children/InspectionModal";
import { useDispatch, useSelector } from "react-redux";
import { getInspectionRequest } from "../../../../redux/action/inspectionRequest";
import Paginations from "../../../commanPage/pagination/Paginations";

function InspectionListTable() {
  const totalNumberRow = 30;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageVisited, setMaxPageVisited] = useState(1);
  const [auctionInformation, setAuctionInformation] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { requestGetData, loadings } = useSelector(
    (state) => state?.inspectionrequestion
  );

  const viewDetailsFunctionality = (items) => {
    setAuctionInformation(items);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    dispatch(getInspectionRequest(currentPage, totalNumberRow));
  }, [dispatch, currentPage, totalNumberRow]);

  if (loadings) {
    return (
      <div className="valign-wrapper justify-center cover white">
        <LoadingSkeleton
          headerData={[
            "Auction ID",
            "Inspection date",
            "Inspection By",
            "Location",
            "Status",
            "Actions",
          ]}
        />
      </div>
    );
  }

  return (
    <>
      <div className={`table-container-style`}>
        <table
          className={`responsive-table centered ${
            isTablet ? "auction_table table-style" : "custom-table-style"
          } `}
        >
          <thead>
            <tr>
              <th>Auction ID</th>
              <th>Inspection date </th>
              <th>Inspection By</th>
              <th>Location</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {requestGetData?.map((items, index) => (
              <tr key={items?._id} className="white black-text">
                <td>{items?.auction?.auctionId || "..."}</td>
                <td>{handleDateSetUp(items?.inspectionDate)}</td>
                <td>{items?.inspectionBy}</td>
                <td style={{ width: "400px" }}>
                  <span className=" NoOfline" style={{ WebkitLineClamp: 1 }}>
                    {items?.inspectionLocation}
                  </span>
                </td>
                <td
                  style={{
                    color: items?.status === "pending" ? "#EAB11F" : "#4EAB33",
                  }}
                >
                  {capitalizeFirstLetter(items?.status)}
                </td>

                <td>
                  <button
                    className="text-decoration-underLine cercle-purple-text bold"
                    onClick={() => {
                      items?.status === "approved"
                        ? viewDetailsFunctionality(items)
                        : navigate(`/inspectList/response/${items?._id}`);
                    }}
                  >
                    {items?.status === "approved"
                      ? "View Response"
                      : "Send Response"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {requestGetData?.length === 0 && <NoItemsLeftInTable />}
      </div>
      {requestGetData?.length !== 0 && (
        <Paginations
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalNumberRow={totalNumberRow}
          totalData={requestGetData?.length}
          maxPageVisited={maxPageVisited}
          setMaxPageVisited={setMaxPageVisited}
        />
      )}
      <Modal
        actions={[]}
        bottomSheet={false}
        fixedFooter={false}
        className="modelAccount"
        id="modalView-details"
        open={isModalOpen}
        options={{
          onCloseEnd: closeModal,
        }}
      >
        <InspectionModal personalDetails={auctionInformation} />
      </Modal>
    </>
  );
}

export default InspectionListTable;
